import React from 'react';
import { CardContent, Card, CardHeader } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import moment from 'moment';
import {  useSelector } from "react-redux";
import { useIntl } from 'react-intl';

const Message = (props) => {

  const { message } = props;
  const {locale} = useIntl()

  const user = useSelector(state => state.securityRedux.user);
  const align = (message?.driverTo?.driverId)?'left':'right';
  const name = (message?.driverTo?.name)?message.driverTo.name:user.fullName;

  let localDate = moment(message?.date).local();

  let lastConnected = ''
  if(message?.date !== "0000-00-00 00:00:00")
      lastConnected = moment(localDate).lang(locale).fromNow()
  
  
  return (
    <Card
      className="card_fsm_message"
      style={{float:align}}
    >
      <div className="card_fsm_message_time">
        <span >
          {lastConnected}
        </span>
      </div>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe">
            {name[0].toUpperCase()}
          </Avatar>
        }
        title={name}
      />
      <CardContent>
        <div className="card_fsm_message_text">
          {message?.message}
        </div>
      </CardContent>
    </Card>
  );
};

export default Message;
